const state = {
  ExternalLink: process.env.VUE_APP_EXTERNAL_LINK,
  windowName: process.env.VUE_APP_WINDOW_NAME,
  name: process.env.VUE_APP_NAME,
}
export default{
  state
}